/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ares_Legal_Form_706Inputs */

const cs_ares_legal_form_706 = /** @type {(inputs: Ares_Legal_Form_706Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Společenství vlastníků jednotek`)
};

const en_ares_legal_form_706 = /** @type {(inputs: Ares_Legal_Form_706Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unit owners association`)
};

/**
* | output |
* | --- |
* | "Unit owners association" |
*
* @param {Ares_Legal_Form_706Inputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const ares_legal_form_706 = /** @type {((inputs?: Ares_Legal_Form_706Inputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ares_Legal_Form_706Inputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ares_legal_form_706(inputs)
	return cs_ares_legal_form_706(inputs)
});